import { injectable } from 'inversify';
import container from '@core/di';
import BaseStore from '@core/stores/base';
import { runInAction } from 'mobx';
import PatientsService, { GetPatientsParams } from '@shared/services/patients';
import { ChildItem, ChildProfile, IAddChild } from '@shared/models/patients';

@injectable()
export default class PatientsStore extends BaseStore<ChildItem, PatientsService> {
  static diToken = Symbol('patients-store');

  constructor() {
    super({ service: container.get<PatientsService>(PatientsService.diToken) });

    this.loading = {
      list: false,
      item: false,
    };
  }

  getList = async (params?: GetPatientsParams) => {
    runInAction(() => {
      this.loading.list = true;
    });

    try {
      const { items, pageInfo } = await this.service.getPatientsList(params);

      runInAction(() => {
        this._list = items;
        this._pageInfo = pageInfo;
      });

      return {
        items,
        pageInfo,
      };
    } finally {
      runInAction(() => {
        this.loading.list = false;
      });
    }
  };

  getChildProfile = async (id: number): Promise<ChildProfile> => {
    return await this.service.getChildProfile(id);
  };

  addChild = async (data: IAddChild, clientId: number) => {
    return await this.service.addChild(data, clientId);
  };

  editChild = async (id: number, data: IAddChild) => {
    return await this.service.editChild(id, data);
  };
}
